(() => {
  function updateBuyTwoTier() {
    document.querySelectorAll('body *').forEach((node) => {
      if (node.children.length || node.textContent.trim().toUpperCase() !== '5% OFF') return;
      let container = node.parentElement;
      let depth = 0;
      while (container && depth < 8 && !/BUY\s*2/i.test(container.textContent || '')) {
        container = container.parentElement;
        depth += 1;
      }
      if (container && /BUY\s*2/i.test(container.textContent || '')) node.textContent = '10% OFF';
    });
  }

  function selectVibrationImage() {
    if (!/vibration[- ]plate/i.test(location.pathname)) return;
    const thumbnails = document.querySelectorAll('.slideshow-controls__thumbnail, button[aria-label^="Slide "]');
    if (thumbnails[1] && thumbnails[1].getAttribute('aria-selected') !== 'true') thumbnails[1].click();
  }

  function ensureCustomerReviews() {
    document.querySelectorAll('.twf-testimonials').forEach((reviews) => {
      const section = reviews.closest('.shopify-section');
      if (section) {
        section.hidden = false;
        section.removeAttribute('aria-hidden');
      }
      reviews.querySelectorAll('.twf-testimonials__notice').forEach((notice) => notice.remove());
      reviews.querySelectorAll('.twf-testimonials__source').forEach((source) => {
        if (/sample|amazon customer review/i.test(source.textContent || '')) source.remove();
      });
    });
  }

  function initV5() {
    updateBuyTwoTier();
    ensureCustomerReviews();
    window.setTimeout(selectVibrationImage, 700);
    window.setTimeout(selectVibrationImage, 1800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initV5, { once: true });
  else initV5();
  document.addEventListener('shopify:section:load', initV5);
})();
